// @ts-strict-ignore
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { Language } from '../../model/enums/language';
import { TranslationKey } from '@tolgee/ngx';
import { TranslationService } from '../../services/translation-service';

@Pipe({
  standalone: true,
  name: 'translateString',
  pure: false,
})
export class TranslateStringPipe implements PipeTransform, OnDestroy {
  private _lastHash?: string;
  private _lastValue?: string;
  private _subscription?: Subscription;
  constructor(private _cdr: ChangeDetectorRef, private _translationService: TranslationService) {}

  ngOnDestroy(): void {
    this._dispose();
  }

  transform(translationKey: TranslationKey): string;
  /**
   * @deprecated Use transform({ translationKey, language?, params? }) instead
   */
  transform(translationKey: TranslationKey, ...languageAndParams: string[]): string;
  transform({
    translationKey,
    language,
    params,
  }: {
    translationKey: TranslationKey;
    language?: Language;
    params?: { [key: string]: string | number };
  }): string;
  transform(...data: any[]): string {
    let props: { translationKey: TranslationKey; language?: Language; params?: { [key: string]: string | number } };

    if (data.length === 1 && typeof data[0] === 'object') {
      props = data[0];
    } else if (data.length === 1 && typeof data[0] === 'string') {
      props = { translationKey: data[0] as TranslationKey };
    } else {
      props = {
        translationKey: data[0] as TranslationKey,
        language: data[1] as Language | undefined,
        params: { legacy: JSON.stringify(data.slice(2)) },
      };
    }

    const hash = JSON.stringify(props);

    if (hash === this._lastHash) {
      return this._lastValue!;
    }

    this._dispose();

    this._lastHash = hash;

    this._subscription = this._translationService.translate$(props).subscribe((value) => {
      this._lastValue = value;
      this._cdr.markForCheck();
    });

    return this._lastValue;
  }

  private _dispose() {
    this._subscription?.unsubscribe();
    this._subscription = undefined;
  }
}
